<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{$t('actionListmod.createTask')}}</h2>
      </div>
      <v-sheet height="64">
        <v-toolbar
          flat
        >
          <v-btn
            outlined
            class="mr-4"
            color="grey darken-2"
            @click="setToday"
          >
           {{$t('actionListmod.tODAY')}}
          </v-btn>
            <v-spacer></v-spacer>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-toolbar-title>
              {{ this.computedDateFormattedMomentjs }}
           </v-toolbar-title>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="next"   
          >
            <v-icon small>
            mdi-chevron-right
            </v-icon>
          </v-btn>
          <!-- <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title> -->
           
          <v-spacer></v-spacer>
          <v-btn class="primary float-right mr-2" @click="cancelTask"
              >{{$t('actionListmod.cANCEL')}}</v-btn
            >
            <v-btn class="primary float-right" @click="createTask"
              >{{$t('actionListmod.sUBMIT')}}</v-btn
            >
        </v-toolbar>
      </v-sheet>
      <br/>
      <v-card elevation="0" class="px-5" color="transparent">
        <v-card-text>
          <template>
            <v-row class="fill-height">
              <v-col cols="3">
                <v-date-picker
                  full-width
                  v-model="today"
                  color="primary"
                  event-color="secondary2"
                  no-title
                ></v-date-picker>
              </v-col>
              <v-col cols="9">
                <v-card>
                  <v-card-text>
                    <v-form
                      @submit.prevent="createTask"
                      ref="taskForm"
                      v-model="valid"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :placeholder="$t('actionListmod.taskName')"
                            v-model="name"
                            :error-messages="errors.name"
                            :rules="taskRules.name"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                          <div class="subtitle">{{$t('actionListmod.startDate')}}</div>
                          <v-menu
                            v-model="startDateModel"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="startDate"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                dense
                                :error-messages="errors.startDate"
                                :rules="taskRules.startDate"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="startDate"
                              @input="startDateSelected"
                              :min="nowDate"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="3">
                          <div class="subtitle">{{$t('actionListmod.endDate')}}</div>
                          <v-menu
                            v-model="endDateModel"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="endDate"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                dense
                                :error-messages="errors.dueDate"
                                :rules="taskRules.dueDate"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="endDate"
                              @input="endDateModel = false"
                              :min="startDate"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="3">
                          <div class="subtitle">{{$t('actionListmod.rEPEAT')}}</div>
                          <v-select
                            :items="repeatTypes"
                            outlined
                            dense
                            v-model="repeat"
                            @input="changedLabel"
                            :error-messages="errors.repeats"
                            :rules="taskRules.repeats"
                          ></v-select>
                        </v-col>
                        <v-col cols="3">
                          <div class="subtitle">{{$t('actionListmod.taskCategory')}}</div>
                          <v-select
                            :items="taskCategory"
                            outlined
                            dense
                            v-model="category"
                            :error-messages="errors.repeats"
                            :rules="taskRules.category"
                          ></v-select>
                        </v-col>
                        <v-col cols="3">
                          <div class="subtitle">{{$t('actionListmod.pRIORITY')}}</div>
                          <v-select
                            :items="priorities"
                            outlined
                            dense
                            placeholder="Priority"
                            v-model="priority"
                            :error-messages="errors.priority"
                            :rules="taskRules.priority"
                          ></v-select>
                        </v-col>
                        <v-col cols="3">
                          <div class="subtitle">{{$t('actionListmod.aSSIGNEE')}}</div>
                          <v-autocomplete
                            v-model="assignee"
                            :items="users"
                            :loading="assigneeLoading"
                            :search-input.sync="assigneeSearch"
                            outlined
                            dense
                            chips
                            small-chips
                            multiple
                            hide-no-data
                            item-text="name"
                            item-value="userNumber"
                            placeholder="Start typing to search"
                            :error-messages="errors.assignees"
                            :rules="taskRules.assignees"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                          <div class="subtitle">{{$t('actionListmod.selectLocation')}}</div>
                          <v-autocomplete
                            v-model="farms"
                            :items="farmsList"
                            :loading="farmsLoading"
                            :search-input.sync="farmSearch"
                            outlined
                            dense
                            chips
                            small-chips
                            multiple
                            hide-no-data
                            item-text="name"
                            item-value="farmNumber"
                            placeholder="Start typing to search"
                            :error-messages="errors.locations"
                            :rules="taskRules.locations"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                          <div class="subtitle">{{$t('gender')}}</div>
                          <v-select
                            :items="genders"
                            outlined
                            dense
                            placeholder="Select Geneder"
                            v-model="gender"
                            @change="getAnimalWithGender"
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <div class="subtitle">{{$t('actionListmod.selectAnimals')}}</div>
                          <AnimalDropdown
                              v-model="animals"
                              :animalType="gender"
                              :farms="farms"
                            />
                        </v-col>
                        <v-col cols="12">
                          <div class="subtitle">{{$t('actionListmod.dESCRIPTION')}}<span class="red--text">*</span></div>
                          <v-textarea
                            outlined
                            name="input-7-4"
                            :placeholder="$t('actionListmod.enterDescription')"
                            v-model="description"
                            :error-messages="errors.description"
                            :rules="taskRules.description"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="2">
                          <v-select
                            :items="statuses"
                            outlined
                            dense
                            :placeholder="$t('pending')"
                            v-model="status"
                            :error-messages="errors.status"
                            :rules="taskRules.status"
                            item-text="name"
                            item-value="value"
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <v-btn type="submit" class="primary float-right"
                            >{{$t('actionListmod.sUBMIT')}}</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar>
    <!-- <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="text-h6">{{$t('actionListmod.customRecurrence')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="inline mt-5">
            <v-row no-gutters>
              <v-col cols="" class="mt-2">
                <p>{{$t('actionListmod.repeatEvery')}}</p>
              </v-col>
              <v-col cols="">
                <v-text-field type="number" v-model="repeatsInterval" outlined dense></v-text-field>
              </v-col>
              <v-col cols="" class="ml-2">
                <v-select type="number" v-model="repeatsFreq" :items="items" item-text="text" outlined dense></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters >
              <v-col v-for="(week,index) in weekDays" :key="index">
                <v-avatar size="20" color="primary" event-color="secondary">
                  <v-btn flat exact icon color="primary" @click="setweekDay(week)" :class="{activeClass: week.selected}"
                    ><span class="white--text">{{week.text}}</span></v-btn>
                </v-avatar>
              </v-col>
            </v-row>
            <div class="mt-5">
              <v-radio-group label="Ends" v-model="repeatEnds">
                  <v-radio name="repeatEnds" label="Never" value="never"></v-radio>
                
                                <v-layout row>
                                      <v-col cols>
                             <v-radio
                    name="repeatEnds"
                    class="mt-2"
                    label="On"
                    value="on"
                    @click="setactive(true)"
                  ></v-radio>
                          </v-col>
                          <v-col cols>
                            <v-menu
                          v-model="drugMfgmenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            :disabled="!active"
                              v-model="onValue"
                              append-icon="mdi-calendar"
                              outlined
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="onValue"
                            @input="drugMfgmenu = false"
                             :min="new Date().toISOString().substr(0, 10)"
                          ></v-date-picker>
                        </v-menu>
                            <v-text-field
                              placeholder=""
                              outlined
                              dense
                              :disabled="this.repeatEnds!=='on'"
                              :value="this.onValue=today"
                            ></v-text-field> 
                          </v-col>
                        </v-layout>
                                    <v-layout row>
                                      <v-col cols>
                             <v-radio
                    name="repeatEnds"
                    class="mt-2"
                    label="After"
                    value="after"
                  ></v-radio>
                          </v-col>
                          <v-col cols>
                            <v-text-field
                              outlined
                              dense
                              type="number"
                               :disabled="this.repeatEnds!=='after'"
                              v-model="afterValue"
                            ></v-text-field>
                          </v-col>
                          <v-col cols>
                            <v-text-field
                              outlined
                              dense
                              :disabled="this.repeatEnds!=='after'"
                              value="Occurrences"
                            ></v-text-field>
                          </v-col>
                        </v-layout>
              </v-radio-group>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
            @click="dialog = false"
          >
            cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            v-on:click="deleteItem(drugid)"
          >
           ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
import UserService from "@/_services/UserService.js";
import FarmService from "@/_services/farmService.js";
import AnimalService from "@/_services/AnimalService.js";

import loading from "@/mixins/LoadingMixin";

import moment from 'moment'
import AnimalDropdown from "@/components/AnimalDropdownMultiTask.vue";

export default {
  components: {
    AnimalDropdown,
  },
  mounted() {
    document.title = "Action List - Create Task";
    
    const selectedAnimal = this.$route.params.animal;
    if (selectedAnimal) {
      this.animals = [selectedAnimal];
    }
  },
  computed: {
    repeatTypes() {
      let day = this.weekday[new Date(this.startDate).getDay()];
      return [
        {
          text: "Doesn't repeat",
          value: "never",
        },
        {
          text: "Daily",
          value: "daily",
        },
        {
          text: `Weekly on ${day}`,
          value: "weekly on monday",
        },
        {
          text: "Monthly",
          value: "monthly on the first monday",
        },
        {
          text: "Weekdays (Monday to Friday)",
          value:"every weekday (monday to friday)"
        },
        {
          text:"Annually",
          value:"anually on jan 2"
        },
        // {
        //   text: "custom",
        // },
      ];
    },
    computedDateFormattedMomentjs () {
      return this.today ? moment(this.today).format('MMMM YYYY') : ''
    },
  },
  watch: {
    assigneeSearch: {
      immediate: true,
      handler(newVal) {
        this.searchAssignee(newVal);
      },
    },
    farmSearch: {
      immediate: true,
      handler(newVal) {
        this.searchFarm(newVal);
      },
    },
    farms: {
      immediate: true,
      handler() {
        console.log('farms', this.farms);
      },
    },
    // animalSearch(val) {
    //   this.searchAnimal(val);
    // },
    animalSearch: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log(newVal, oldVal)
        this.searchAnimal(newVal);
      },
    },
    repeatTypes() {
      this.repeatDay = new Date(this.startDate).getDay();
    },
    startDate(d) {
      this.endDate = d;
    },
  },
  data: () => ({
    genders: ['All', 'Male', 'Female'],
    gender: "All",
    valid: true,
    dialog: false,
    drugMfgmenu:false,
    items:["day","week","year","month"],
    weekday:[
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    taskCategory:[
      "Medical",
      "Insemination",
      "others",
    ],
    weekDays:[
      {
          text: "S",
          value: "su",
          selected: false
        },
         {
          text: "M",
          value: "mo",
          selected: false
        },
         {
          text: "T",
          value: "tu",
          selected: false
        },
         {
          text: "W",
          value: "we",
          selected: false
        },
         {
          text: "T",
          value: "th",
          selected: false
        },
         {
          text: "F",
          value: "fr",
          selected: false
        },
         {
          text: "S",
          value: "sa",
          selected: false
        },
      ],
    errors: {
      name: "",
      startDate: "",
      dueDate: "",
      priority: "",
      description: "",
      assignees: "",
      locations: "",
      animals: "",
      repeats: "",
    },
    taskRules: {
      name: [(v) => !!v || "Task name is required"],
      startDate: [(v) => !!v || "Start date is required"],
      dueDate: [(v) => !!v || "End date is required"],
      priority: [(v) => !!v || "Priority is required"],
      description: [(v) => !!v || "Description is required"],
      assignees: [],
      locations: [],
      animals: [],
      repeats: [],
      category:[],
    },
    snackbarText: "",
    snackbar: false,
    name: "",
    repeatDay: 0,
    startDateModel: false,
    endDateModel: false,
    nowDate: new Date().toISOString().slice(0, 10),
    startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    repeat: "never",
    animals: [],
    selected: null,
    animalList: [],
    animalLoading: false,
    animalSearch: "",
    farms: [],
    farmsList: [],
    farmsLoading: false,
    farmSearch: "",
    users: [],
    category:"Medical",
    assignee: [],
    assigneeSearch: "",
    assigneeLoading: false,
    priority: "low",
    priorities: [
      { text: "Low", value: "low" },
      { text: "Medium", value: "medium" },
      { text: "High", value: "high" },
      { text: "Urgent", value: "urgent" },
    ],
    statuses: [ 
      {
        name:"Pending",
        value:"pending"
      }, 
      {
        name:"In Progress",
        value:"inprogress"
      }, 
      {
        name:"Complete",
        value:'done'
      }
    ],
    status: "pending",
    description: "",
    repeatWeekDays: [],
    repeatEndValue:"",
    repeatsInterval:"",
    repeatsFreq:"",
    repeatEnds:"",
    onValue: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    afterValue:"",
    active:false,
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "Action List",
        disabled: false,
        to: { name: "ActionList" },
        exact: true,
      },
      {
        text: "Create Task",
        disabled: true,
      },
    ],
  }),
  methods: {
    getAnimalWithGender() {
      // if(this.gender != 'All')
        this.animals = [];
      // this.animalList = []
      // if(this.gender != "All") {
      //   AnimalService.getAnimalWithGender(
      //   this.gender.toLowerCase(),
      //   {
      //       page: 1,
      //       itemsPerPage: 2000,
      //   },
      //   ""
      // )
      //   .then(res => res.data)
      //   .then(data => {
      //     this.animalList = data.animalList;
      //   })
      //   .catch(e => {
      //     console.log("error", e);
      //     this.loading = false;
      //   });
      // }else{
      //   this.searchAnimal("")
      // }
    },

    getAnimalText(item) {
      return `${item.animalNumber} (${item?.gender || this.gender})`
    },
    startDateSelected() {
      this.startDateModel = false;
    },
    searchAssignee(val) {
      // if (val == "" || val == null) return;
      this.assigneeLoading = true;
      UserService.searchUsers(val)
        .then((res) => {
          console.log(res)
          this.users = res.data.users;
        })
        .catch((err) => {
          console.log(err);
          this.users = [];
        })
        .finally(() => (this.assigneeLoading = false));
    },
    setactive(val){
      this.active=val
    },
    searchFarm(val) {
      // if (val == "" || val == null) return;
      this.farmsLoading = true;
      FarmService.searchFarms(val)
        .then((res) => {
          console.log(res);
          this.farmsList = res.data.farms;
        })
        .catch((err) => {
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.farmsLoading = false));
    },

    searchAnimal(val) {
      // if (val == "" || val == null) return;
      this.animalLoading = true;
      AnimalService.searchAnimal(val)
        .then((res) => {
          console.log(res);
          this.animalList = res.data.animals;
        })
        .catch((err) => {
          console.log(err);
          this.animalNumber = [];
        })
        .finally(() => (this.animalLoading = false));
    },

    setweekDay(week){
      week.selected = !week.selected

      if(week.selected){
      this.repeatWeekDays.push(week.value);
      }
      else{
      let index = this.repeatWeekDays.indexOf(week.value);
        this.repeatWeekDays.splice(index, 1);
      }

      console.log("this.repeatWeekDays",this.repeatWeekDays)
    },  
    changedLabel(event) {
      this.selected = event;
      // if (this.selected == "custom") {
      //   this.dialog = true;
      // }
    },
    createTask() {
      // console.log('ctasks', this.animals)
      const animalNunbers = this.animals.map(({animalNumber}) => animalNumber)
      if (!this.$refs.taskForm.validate()) return;
      this.startLoading();
      if(this.repeatEnds=="on"){
        this.repeatEndValue=this.onValue
      }
      if(this.repeatEnds=="after"){
        this.repeatEndValue=this.afterValue
      }
      let data = {
        name: this.name,
        startDate: this.startDate,
        dueDate: this.endDate,
        priority: this.priority,
        description: this.description,
        assignees: this.assignee,
        locations: this.farms,
        animals: animalNunbers,
        repeats: this.repeat,
        status: this.status,
        category:this.category,
        repeatWeekDays: this.repeatWeekDays,
        repeatEndValue:this.repeatEndValue,
        repeatsInterval:this.repeatsInterval,
        repeatsFreq:this.repeatsFreq,
        repeatEnds:this.repeatEnds,
      };
      console.log("data",data)
      this.$store
        .dispatch("createTask", data)
        .then((res) => {
          if(res.status == 500) throw new Error();
          console.log('rese', res);
          if (res.status == 422) {
            res.data.message.errors.forEach((em) => {
              this.errors[em.param] = em.msg;
            });
          } else {
            this.$notify({
              title: "Task created successfully ",
              text: "Task created successfully.",
              type: "success",
            });
            this.$router.push({ name: "DailyTask" });
          }
        })
        .catch((err) => {
          console.log("err", err.response);
        })
        .finally(() => {
          this.stopLoading();
        });
      // console.log('start', this.startDate)
      // console.log('end', this.endDate)
      // console.log('repeat', this.repeat)
      // console.log('assignee', this.assignee)
      // console.log('priority', this.priority)
      // console.log('farms', this.farms)
      // console.log('animals', this.animals)
      // console.log('description', this.description)
      // console.log('status', this.status)
    },
    cancelTask(){
      this.$router.push({ name: "ActionList" });
    },
    setToday () {
      this.today = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
    },
    prev () {
      // this.$refs.calendar.prev()

       var currentDage = new Date();
      var myPastDate=new Date(this.today); 

      if(myPastDate.getTime() < currentDage.getTime()){
        return;
      }

      myPastDate.setMonth(myPastDate.getMonth()-1);
      let month = `${myPastDate.getMonth()+1}`;

      if(myPastDate.getMonth()+1 < 10){
        month = '0'+month
      }
      this.today = myPastDate.getFullYear()+"-"+month+"-"+myPastDate.getDate();

    },
    next () {
      // this.$refs.calendar.next()
      var myPastDate=new Date(this.today); 
      myPastDate.setMonth(myPastDate.getMonth()+1);
      let month = `${myPastDate.getMonth()+1}`;

      if(myPastDate.getMonth()+1 < 10){
        month = '0'+month
      }
      this.today = myPastDate.getFullYear()+"-"+month+"-"+myPastDate.getDate();
    },
  },
  mixins: [loading],
};
</script>
<style lang="scss">
.activeClass {
    background-color: olive!important;
}
</style>